import { Box } from "@mui/material";
import styled from "styled-components";

export const MultiStepperStyled = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  .container-wrapper {
    max-width: 600px;
    width: 100%;
    padding: 20px;

    @media (max-width: 1024px) {
      padding: 20px;
    }

    @media (max-width: 768px) {
      padding: 16px;
    }
  }
`;
